import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { AuthenticationService, ConnectCoreModule, ConnectCoreModuleConfig } from '@aveva/connect-web-core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { ErmSdkModule, IErmApiClientConfig } from 'erm-sdk';
import { ErmDevOpsModule } from './ui/erm-devops.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

const cachePrefix = 'connect_erm_devops_app';
const coreModuleConfig: ConnectCoreModuleConfig = {
  authentication: {
    authority: environment.authority,
    clientId: environment.clientId,
    singleSignOutUrl: environment.singleSignOutUrl,
    cachePrefix: cachePrefix
  },
  authorization: {
    cachePrefix: cachePrefix
  },
  connectApi: {
    registry: environment.apis.registry,
    am: environment.apis.am,
    scm: environment.apis.scm,
    uam: environment.apis.uam,
    assets: environment.apis.assets
  },
  components: {
    appHeaderTitle: 'ERM DevOps 🦄',
    appHeaderLogoPath: '',
    sideNavLogoPath: '/assets/imgs/AVEVA-Cloud_interimmark_rev01-01_black.svg',
    termsAndConditions: 'https://sw.aveva.com/legal',
    connectLink: environment.connect,
    myProfileLink: environment.userProfileManagementUrl
  }
};

export function HttpLoaderFactory(http: HttpClient): TranslateLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function ErmApiClientConfigFactory(authenticationService: AuthenticationService): IErmApiClientConfig
{
  const config: IErmApiClientConfig = {
    ermDevOpsApiBaseUrl: environment.apis.ermDevOps,
    enableLogging: false,
    authHeaderResolver: () => authenticationService.getToken()
      .then(token => `Bearer ${token}`)
      .catch(error => {
        console.error('ErmApiClientConfigFactory authHeaderResolver error', error);
        return null;
      })
  };
  return config;
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation()),
    provideAnimationsAsync(),
    importProvidersFrom(
      ConnectCoreModule.forRoot(coreModuleConfig),
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      }),
      ErmSdkModule.forRoot({
        ermApiClientConfigFactory: ErmApiClientConfigFactory,
        ermApiClientConfigFactoryDependencies: [AuthenticationService]
      }),
      ErmDevOpsModule
    )
  ]
};
